import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "flex flex-col items-start gap-1",
  "data-testid": "document-status-badge"
}
const _hoisted_2 = {
  key: 0,
  class: "text-[11px] leading-4 text-negative text-left"
}

import { computed } from 'vue'
import { mdiAlertCircleOutline, mdiCheckCircle, mdiClockTimeThree } from '@mdi/js'

import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import type { LabelBadgeColor } from '@/components/designSystem/Badges/LabelBadge.vue'
import { ProfessionalDocumentStatus } from '@/types/professional-documents.types'
import type {
  DocumentRejection,
  ProfessionalDocumentPendingReason
} from '@/types/professional-documents.types'

import { DOCUMENT_STATUS_LABEL, pendingReasonText } from './labels'


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentStatusBadge',
  props: {
    status: {},
    pendingReason: { default: null },
    rejection: { default: null },
    expiresAt: { default: null },
    isLegacy: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;



const VISUAL: Record<ProfessionalDocumentStatus, { color: LabelBadgeColor; icon: string }> = {
  [ProfessionalDocumentStatus.PENDING]: { color: 'red', icon: mdiAlertCircleOutline },
  [ProfessionalDocumentStatus.IN_REVIEW]: { color: 'yellow', icon: mdiClockTimeThree },
  [ProfessionalDocumentStatus.CONCLUDED]: { color: 'green', icon: mdiCheckCircle }
}

const config = computed(() => ({
  ...VISUAL[props.status],
  label:
    props.isLegacy && props.status === ProfessionalDocumentStatus.CONCLUDED
      ? 'Concluído (legado)'
      : DOCUMENT_STATUS_LABEL[props.status]
}))

const reasonText = computed(() =>
  pendingReasonText({
    status: props.status,
    pendingReason: props.pendingReason,
    rejection: props.rejection,
    expiresAt: props.expiresAt
  })
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LabelBadge, {
      label: config.value.label,
      color: config.value.color,
      icon: config.value.icon,
      size: "small"
    }, null, 8, ["label", "color", "icon"]),
    (reasonText.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(reasonText.value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})